export const LOGIN_URL = "https://login.kast-dev.net";

// Where signIn (auth/session.ts) keeps the path to come back to, in
// sessionStorage, for a sign-in that returns to another page.
export const POST_LOGIN_PATH_KEY = "post_login_path";
